<div class="container">
  <div id="filter-card">
    <dxo-card data-e2e="filter-employees-card">
      <div class="header-container">
        <h2 class="card-body-header" data-e2e="MemberCardHeader">Filter employees</h2>
        <div (click)="clearFilters()" (keydown)="clearFilters()" class="link">Reset filters</div>
      </div>
      <card-body>
        <form [formGroup]="formGroup" (ngSubmit)="submit()">
          <div class="data-containter">
            <div class="row-input">
              <dxo-text-input
                label="Employee name"
                maxlength="80"
                class="employeeName"
                formControlName="employeeName"
                (valueChange)="employeeName$.next($event)"
                [dxoDataset]="[{ selector: 'input', data: { e2e: 'employee-name-field' } }]"
              ></dxo-text-input>

              <dxo-dropdown
                label="Status"
                class="statusdropdown"
                [dxoDataset]="[{ selector: '.dxo-input, ul', data: { pii: '', e2e: 'status-dropdown' } }]"
                (valueChange)="onFilterChange($any($event), 'status')"
                [optionsObjects]="StatusOptions"
                [value]="searchParameter.status"
              ></dxo-dropdown>

              <dxo-dropdown
                label="Bill division"
                class="billlocationdropdown"
                [dxoDataset]="[{ selector: '.dxo-input, ul', data: { pii: '', e2e: 'bill-division-dropdown' } }]"
                (valueChange)="onFilterChange($any($event), 'billingDivision')"
                [optionsObjects]="billLocationOptions"
                [value]="searchParameter.billingDivision"
              ></dxo-dropdown>
            </div>
          </div>
        </form>
      </card-body>
    </dxo-card>
  </div>

  <div id="list-card">
    <dxo-card data-e2e="employee-list-card">
      <div class="header-container">
        <h2 class="card-body-header" data-e2e="member-list-card-header">Employee list</h2>
      </div>
      <div class="loader-container">
        <dxo-circular-loader *ngIf="isLoading" [size]="'medium'" [color]="'blue'"></dxo-circular-loader>
      </div>
      <card-body *ngIf="members$ | async as members">
        <dxo-data-table
          [headers]="tableHeaders"
          [items]="members.listMember"
          [showCardViewWhenMobile]="true"
          [dxoDataset]="[{ selector: 'dxo-table-cell > span', data: { pii: '' } }]"
          data-e2e="employee-listing-table"
        >
          <ng-template dxoHeaderKey="employeeName">
          <span
            tabindex="0"
            class="sort-header"
            (click)="onClickTableHeader('LastName')"
            (keypress)="onClickTableHeader('LastName')"
          >
            Employee name
            <dxo-icon
              [class.ascending]="
                searchParameter.sortDirection === 'Ascending' && searchParameter.sortField === 'LastName'
              "
              [color]="searchParameter.sortField === 'LastName' | getSortIconColor"
              [fontSize]="20"
              [right]="true"
            >
              sort
            </dxo-icon>
          </span>
          </ng-template>

          <ng-template dxoHeaderKey="status">
          <span
            tabindex="0"
            class="sort-header"
            (click)="onClickTableHeader('Status')"
            (keypress)="onClickTableHeader('Status')"
          >
            Status
            <dxo-icon
              [class.ascending]="
                searchParameter.sortDirection === 'Ascending' && searchParameter.sortField === 'Status'
              "
              [color]="searchParameter.sortField === 'Status' | getSortIconColor"
              [fontSize]="20"
              [right]="true"
            >sort
            </dxo-icon>
          </span>
          </ng-template>

          <ng-template dxoHeaderKey="billingDivision">
          <span
            tabindex="0"
            class="sort-header"
            (click)="onClickTableHeader('BillingDivision')"
            (keypress)="onClickTableHeader('BillingDivision')"
          >
            Bill division
            <dxo-icon
              [class.ascending]="
                searchParameter.sortDirection === 'Ascending' && searchParameter.sortField === 'BillingDivision'
              "
              [color]="searchParameter.sortField === 'BillingDivision' | getSortIconColor"
              [fontSize]="20"
              [right]="true"
            >
              sort
            </dxo-icon>
          </span>
          </ng-template>

          <ng-template dxoKey="employeeName" let-item let-index="index">
            <div class="emp-name">
              <div>
                <dxo-button-v2
                  variant="link"
                  [label]="item.lastName + ', ' + item.firstName"
                  [routerLink]="`/benefits/employees/${item.employeeId}/contracts/${item.contractId}`"
                  [queryParams]="{token}"
                  [attr.data-e2e]="'employee-name-' + index"
                />
              </div>
              <div>({{ item.dob }})</div>
            </div>
          </ng-template>

          <ng-template dxoKey="billDivision" let-item let-index="index">
            <span class="list-cell" [attr.data-e2e]="'bill-division-' + index">{{ item.billingDivision }}</span>
          </ng-template>

          <ng-template dxoKey="status" let-item let-index="index">
          <span class="row-cell">
            <span class="status-indicator" [style.background-color]="item.indicator" [attr.data-e2e]="'status-' + index"></span>
            {{ item.status }}
          </span>
          </ng-template>
        </dxo-data-table>

        <div class="paginator">
          <dxo-server-pagination
            [itemCount]="members.totalResults"
            [currentPage]="searchParameter.page"
            [pageSize]="searchParameter.pageSize"
            (pageChange)="onPageChange($event)"
            (pageSizeChange)="onPageSizeChange($event)"
          ></dxo-server-pagination>
        </div>
      </card-body>
    </dxo-card>
  </div>
</div>